import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import mea from '../../../services/mea';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import AuthenticatedHome from '../../../components/home/authenticated'
import NotAuthenticatedHome from "../../../components/home/not-authenticated";
import { showModal } from '../../../services/modal/actions';

const AuthenticatedHomePage = withTemplate(AuthenticatedHome, PrimaryTemplate, {
    hideBreadcrumb: true
})

const HomePage = ({ isAuthenticated, showModal, i18nHome, ...props }) => {
    if (isAuthenticated) {
        return <AuthenticatedHomePage i18Home={i18nHome.AUTHENTICATED} {...props} />
    } else {
        return <NotAuthenticatedHome i18nHome={i18nHome.NOT_AUTHENTICATED} showModal={showModal} />
    }
};

HomePage.propTypes = {
    carrouselMeas: PropTypes.array,
    selectionMomentMeas: PropTypes.array,
    i18nHome: PropTypes.object.isRequired,
    partners: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => ({
    carrouselMeas: mea.selectors.getMeasListByTypeId(state, mea.constants.CAROUSEL_MEA_TYPE),
    onlineOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.ONLINE_OFFER),
    i18nHome: state.i18n.page.HOME,
    partners: state.partner.partners,
    isAuthenticated: state.authentication.isAuthenticated
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js